import { render, staticRenderFns } from "./pdfPreview.vue?vue&type=template&id=ba8ccfb8&scoped=true"
import script from "./pdfPreview.vue?vue&type=script&lang=js"
export * from "./pdfPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8ccfb8",
  null
  
)

export default component.exports